<template>
  <div id="app">
    <GmapMap
      :center="center"
      :zoom="14"
      map-type-id="terrain"
      style="width: 100%; height: 600px"
      ref="mapRef"
      :options="mapOptions"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
        :zIndex="9999999"
      />
      <GmapMarker
        :key="index"
        v-for="(marker, index) in filteredStores"
        :position="{lat: parseFloat(marker.coordinates.lat),lng: parseFloat(marker.coordinates.lng)}"
        :clickable="true"
        :draggable="false"
        @click="panToAndClick(marker)"
      />
    </GmapMap>

    <div class="section notopborder nomargin">
      <div class="container">
        <div class="heading-block nobottomborder center">
          <h2 class="nott t600" style="margin-bottom: 30px;">TEILNEHMENDE GESCHÄFTE</h2>
          <div class="form-group">
            <select v-model="filterBy" class="form-control">
              <option value="all">Alle Branchen</option>
              <option value="gastro">Gastronomie</option>
              <option value="einzelhandel">Einzelhandel</option>
              <option value="dienstleistung">Dienstleistung</option>
            </select>
          </div>
        </div>
      </div>
      <div class="container clearfix">
        <transition-group name="fade" tag="div" class="row">
          <div
            class="col-md-3 col-sm-6"
            style="margin-bottom:20px;"
            v-for="store in filteredStores"
            :key="store.id"
          >
            <div
              class="card shadow-sm border-light"
              @click="panToAndClick(store)"
              @mouseenter="panTo(store)"
              style=" height:100%"
            >
              <div class="card-body">
                <h5 class="card-title t600">{{store.title}}</h5>
                <p class="card-text" style="min-height: 70px; margin-bottom:15px">
                  {{store.address}}
                  <br />
                  {{store.plz}} Duisburg
                  <br />
                  <span v-if="store.tel">Tel: {{store.tel}}</span>
                </p>
                <span class="g_btn" style="margin-right: 15px;">
                  <a class="g_link" v-bind:href="'mailto:'+store.email">E-MAIL</a>
                </span>
                <span class="g_btn">
                  <a class="g_link" v-bind:href="store.website" target="_blank">WEBSITE</a>
                </span>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},

  data() {
    return {
      stores: [],
      center: { lat: 51.43203159999999, lng: 6.7618111 },
      filterBy: "all",
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: false
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: "hallo",

        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  mounted() {
    this.axios
      .get("https://www.duisburgistecht.de/api/teilnehmer")
      .then(response => (this.stores = response.data));
  },

  methods: {
    panToAndClick(marker) {
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: parseFloat(marker.coordinates.lat),
          lng: parseFloat(marker.coordinates.lng)
        });
      });
      this.toggleInfoWindow(marker, marker.id);
    },
    panTo(marker) {
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: parseFloat(marker.coordinates.lat),
          lng: parseFloat(marker.coordinates.lng)
        });
      });
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = {
        lat: parseFloat(marker.coordinates.lat),
        lng: parseFloat(marker.coordinates.lng)
      };
      this.infoOptions.content =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<h1 style="margin:0 0 10px 0">' +
        marker.title +
        "</h1>" +
        '<div id="bodyContent">' +
        "<p><b>" +
        marker.address +
        "</b> <br> " +
        marker.plz +
        " Duisburg </p>" +
        "</div>" +
        "</div>";

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  },

  computed: {
    filteredStores: function() {
      var filteredStores_ = this.stores;
      var vm = this;
      var filterBy = vm.filterBy;

      if (filterBy === "all") {
        return this.stores;
      }

      filteredStores_ = this.stores.filter(function(store) {
        return store.branche === filterBy;
      });

      return filteredStores_;
    }
  }
};
</script>


<style >
.fade-enter-active,
.fade-leave-activ {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.vue-map {
  height: 100% !important;
}
.g_btn {
  padding: 10px 15px;
  border-radius: 2px;
  cursor: default;
  font-family: arial, sans-serif;
  font-size: 11px;
  font-weight: bold;
  height: 27px;
  line-height: 27px;
  margin: 2px 0;
  min-width: 54px;
  text-align: center;
  -webkit-transition: color 0.218s;
  -webkit-user-select: none;
  background-color: #f5f5f5;
  background-image: linear-gradient(top, #f5f5f5, #f1f1f1);
  border: 1px solid #dcdcdc;
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: #444;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#f5f5f5),
    to(#f1f1f1)
  );
  background-image: -webkit-linear-gradient(top, #f5f5f5, #f1f1f1);
}
.g_link {
  display: inline-block;
  color: #444;
}
</style>